import type { Flash } from "@/types";

type FlashMessageProps = {
  className?: string;
  flash?: Flash;
};

export default function FlashMessage({ flash, className = "mb-6" }: FlashMessageProps) {
  const error = flash?.error;
  const notice = flash?.notice || flash?.alert;

  if (!error && !notice) {
    return null;
  }

  const isError = Boolean(error);
  const message = error || notice;

  return (
    <div
      id="flash-message"
      data-testid="flash-message"
      role="alert"
      className={`rounded-md border px-4 py-3 text-sm ${className} ${
        isError ? "border-red-200 bg-red-50 text-red-800" : "border-primary-200 bg-primary-50 text-primary-900"
      }`}
    >
      {message}
    </div>
  );
}
